import {Button} from "../../../basic/button.tsx";
import {Plus} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface LicenseActionsProps {
    totalLicenses: number;
    onCreateLicense: () => void;
}

export function LicenseActions({totalLicenses, onCreateLicense}: LicenseActionsProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="flex items-center gap-2">
            <p className="text-muted-foreground">{t('admin.licenses.totalLicenses')}: {totalLicenses}</p>
            <Button onClick={onCreateLicense}>
                <Plus className="h-4 w-4 mr-2"/>
                {t('admin.licenses.createLicenseButton')}
            </Button>
        </div>
    );
}